if (!customElements.get('pinch-zoom-enabler')) {
  customElements.define(
    'pinch-zoom-enabler',
    class PinchZoomEnabler extends HTMLElement {
      constructor() {
        super();
        this.isPinching = false;
        this.isProcessing = false; // Prevent rapid-fire events
        this.lastGestureTime = 0; // Track last gesture
        this.reenableTimeout = null; // Track timeout
      }

      connectedCallback() {
        this.setupEventListeners();
      }

      // Swiper stores its instance on the element; it may initialize after this connects
      get swiperInstance() {
        return this.swiper;
      }

      setupEventListeners() {
        // Touch events to detect pinch. Passive: the handlers never call preventDefault,
        // so the browser can scroll and zoom without waiting for them.
        this.onTouchStart ||= this.handleTouchStart.bind(this);
        this.onTouchEnd ||= this.handleTouchEnd.bind(this);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
      }

      handleTouchStart(e) {
        // Detect 2-finger pinch gesture
        if (e.touches.length === 2) {
          // Throttle rapid gestures - prevent crash from too many events
          const now = Date.now();
          if (now - this.lastGestureTime < 100) {
            return; // Ignore if less than 100ms since last gesture
          }
          this.lastGestureTime = now;
          
          // Prevent processing if already handling a gesture
          if (this.isProcessing) return;
          
          this.isPinching = true;
          this.isProcessing = true;
          
          // Clear any pending re-enable timeout
          if (this.reenableTimeout) {
            clearTimeout(this.reenableTimeout);
            this.reenableTimeout = null;
          }
          
          // Disable Swiper immediately to allow native browser zoom
          if (this.swiperInstance && this.swiperInstance.enabled) {
            try {
              this.swiperInstance.disable();
            } catch (error) {
              // Silently handle any errors during disable
            }
          }
        }
      }

      handleTouchEnd(e) {
        // Re-enable Swiper when all fingers are lifted
        if (e.touches.length === 0 && this.isPinching) {
          this.isPinching = false;
          
          // Clear any existing timeout
          if (this.reenableTimeout) {
            clearTimeout(this.reenableTimeout);
          }
          
          if (this.swiperInstance) {
            // Delay to ensure zoom gesture completes
            this.reenableTimeout = setTimeout(() => {
              try {
                if (this.swiperInstance && !this.swiperInstance.enabled) {
                  this.swiperInstance.enable();
                }
              } catch (error) {
                // Silently handle any errors during enable
              } finally {
                // Reset processing flag
                this.isProcessing = false;
                this.reenableTimeout = null;
              }
            }, 300); // Increased delay for stability
          } else {
            this.isProcessing = false;
          }
        }
      }

      disconnectedCallback() {
        // Clear any pending timeouts
        if (this.reenableTimeout) {
          clearTimeout(this.reenableTimeout);
          this.reenableTimeout = null;
        }
        
        // Clean up event listeners
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        this.removeEventListener('touchcancel', this.onTouchEnd);
        
        // Re-enable Swiper if it was disabled
        if (this.swiperInstance && !this.swiperInstance.enabled) {
          try {
            this.swiperInstance.enable();
          } catch (error) {
            // Silently handle cleanup errors
          }
        }
      }
    }
  );
}

